export default {
  QUIZ_LOAD: 'QUIZ_LOAD',
  QUIZ_FETCHED: 'QUIZ_FETCHED',
};
